import produce, { Draft } from 'immer';
import { FavouriteConversationsState } from './_types';
import { initialState } from './_initialState';
import {
    SET_FAVOURITE_CONVERSATIONS,
    CLEAR_FAVOURITE_CONVERSATIONS,
} from './_actionTypes';

// * Implements the producer from ImmerJS.
// Notice that it is not needed to handle the default case, a producer that doesn't do anything will simply return the original state.
const favouriteConversationsReducer = produce(
    (
        draft: Draft<FavouriteConversationsState> = initialState,
        action
    ): FavouriteConversationsState => {
        switch (action.type) {
            case SET_FAVOURITE_CONVERSATIONS:
                draft.favouriteConversations = action.payload;
                break;
            case CLEAR_FAVOURITE_CONVERSATIONS:
                draft.favouriteConversations =
                    initialState.favouriteConversations;
                break;
        }
        return draft;
    }
);

export default favouriteConversationsReducer;
